/**
 * Get access to the GTM datalayer
 */

let dataLayer;

if (typeof window !== "undefined") {
  dataLayer = window.dataLayer || [];
} else {
  dataLayer = [];
}

export function gtm(event) {
  dataLayer.push(event);
}
